import { Navigate, useLocation } from "react-router-dom";
import { JSX } from "react";
import { useUser } from "../../shared/hooks/useUser";

interface RequireAuthProps {
    children: JSX.Element;
}

export function RequireAuth({ children }: RequireAuthProps) {
    const { user } = useUser();
    const location = useLocation();
    if (!user) {
        return <Navigate to={"/main"} state={{ from: location }} replace />;
    }

    return children;
}
